import React from 'react';
import { useNavigate } from 'react-router-dom';

const TABS = [
  { path: '/builder/inventory/transfers', label: 'Transfer / lend stock' },
  { path: '/builder/inventory/lends', label: 'Lent & borrowed' }
];

/**
 * Transfers and Lends are one page with two tabs (warehouse Phase 3). Each tab
 * keeps its own URL so links to either still work; the project carries over.
 */
const TransferLendTabs = ({ active, projectId }) => {
  const navigate = useNavigate();
  return (
    <div className="mb-5 flex gap-6 overflow-x-auto border-b border-gray-200" role="tablist">
      {TABS.map((tab) => {
        const selected = tab.path === active;
        return (
          <button
            key={tab.path}
            type="button"
            role="tab"
            aria-selected={selected}
            onClick={() =>
              !selected &&
              navigate(tab.path, { state: projectId ? { projectID: Number(projectId) } : undefined })
            }
            className={`-mb-px whitespace-nowrap border-b-2 px-1 pb-2 text-sm font-semibold ${
              selected
                ? 'border-[#2A565E] text-[#2A565E]'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}>
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default TransferLendTabs;
